import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";

// Menu
export interface Menu {
    headTitle1?: string;
    headTitle2?: string;
    path?: string;
    title?: string;
    icon?: string;
    type?: string;
    badgeType?: string;
    badgeValue?: string;
    active?: boolean;
    bookmark?: boolean;
    children?: Menu[];
    modulo?: number;
    seccion?: number;
}

@Injectable({
    providedIn: "root",
})
export class NavService implements OnDestroy {
    private unsubscriber: Subject<any> = new Subject();
    public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

    // Search Box
    public search: boolean = false;

    // Language
    public language: boolean = false;

    // Mega Menu
    public megaMenu: boolean = false;
    public levelMenu: boolean = false;
    public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

    // Collapse Sidebar
    public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

    // For Horizontal Layout Mobile
    public horizontal: boolean = window.innerWidth < 991 ? false : true;

    // Full screen
    public fullScreen: boolean = false;

    constructor(
        private router: Router
    ) {
        this.setScreenWidth(window.innerWidth);
        fromEvent(window, "resize")
        .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
        .subscribe((evt: any) => {
            this.setScreenWidth(evt.target.innerWidth);
            if (evt.target.innerWidth < 991) {
                this.collapseSidebar = true;
                this.megaMenu = false;
                this.levelMenu = false;
            }
            if (evt.target.innerWidth < 1199) {
                this.megaMenuColapse = true;
            }
        });
        if (window.innerWidth < 991) {
            // Detect Route change sidebar close
            this.router.events.subscribe((event) => {
                this.collapseSidebar = true;
                this.megaMenu = false;
                this.levelMenu = false;
            });
        }
    }

    ngOnDestroy() {
        // this.unsubscriber.next();
        this.unsubscriber.complete();
    }

    private setScreenWidth(width: number): void {
        this.screenWidth.next(width);
    }

    MENUITEMS: Menu[] = [
        {
            path: "/app/inicio",
            title: "Inicio",
            icon: "icofont-home",
            type: "link",
            bookmark: true,
            active: true,
        },
        {
            title: "Cotizaciones",
            icon: "icofont-tasks-alt",
            type: "sub",
            active: false,
            modulo: 1,
            children: [
                { 
					path: '/app/cotizaciones/cotizaciones',
					title: 'Cotizaciones',
					type: 'link',
					seccion: 28
				}
            ]
        },
        {
            title: "Notas de Venta",
            icon: "icofont-ui-clip-board",
            type: "sub",
            active: false,
            modulo: 2,
            children: [
                { 
					path: '/app/notas-venta/listado',
					title: 'Notas de Venta',
					type: 'link',
					seccion: 29
				}
            ]
        },
        {
            title: "Seguimientos",
            icon: "icofont-location-pin",
            type: "sub",
            active: false,
            modulo: 3,
            children: [
                { 
					path: '/app/seguimientos/importaciones',
					title: 'Importaciones',
					type: 'link',
					seccion: 27
				},
                { 
					path: '/app/seguimientos/exportaciones',
					title: 'Exportaciones',
					type: 'link',
					seccion: 27
				}
            ]
        },
        {
            title: "Recursos",
            icon: "icofont-box",
            type: "sub",
            active: false,
            modulo: 4,
            children: [
                { 
					path: '/app/recursos/productos',
					title: 'Productos',
					type: 'link',
					seccion: 15
				},
                { 
					path: '/app/recursos/servicios',
					title: 'Servicios',
					type: 'link',
					seccion: 16
				},
                { 
					path: '/app/recursos/detalles',
					title: 'Detalles',
					type: 'link',
					seccion: 31
				},
                { 
					path: '/app/recursos/familias',
					title: 'Familias',
					type: 'link',
					seccion: 17
				},
                { 
					path: '/app/recursos/sub-familias',
					title: 'Sub-Familias',
					type: 'link',
					seccion: 18
				},
                { 
					path: '/app/recursos/marcas',
					title: 'Marcas',
					type: 'link',
					seccion: 19
				},
                { 
					path: '/app/recursos/modelos',
					title: 'Modelos',
					type: 'link',
					seccion: 20
				},                
                { 
					path: '/app/recursos/unidades-medida',
					title: 'Unidades de Medida',
					type: 'link',
					seccion: 21
				},
                { 
					path: '/app/recursos/ubicaciones',
					title: 'Ubicaciones',
					type: 'link',
					seccion: 22
				}
            ]
        },
        {
            title: "Personas",
            icon: "icofont-users-alt-1",
            type: "sub",
            active: false,
            modulo: 5,
            children: [
                { 
					path: '/app/personas/clientes',
					title: 'Clientes',
					type: 'link',
					seccion: 11
				},
                { 
					path: '/app/personas/trabajadores',
					title: 'Trabajadores',
					type: 'link',
					seccion: 12
				},
                { 
					path: '/app/personas/departamentos',
					title: 'Departamentos',
					type: 'link',
					seccion: 13
				},
                { 
					path: '/app/personas/cargos',
					title: 'Cargos',
					type: 'link',
					seccion: 14
				}
            ]
        },
        {
            title: "Mantenedores",
            icon: "icofont-justify-all",
            type: "sub",
            active: false,
            modulo: 6,
            children: [
                { 
					path: '/app/mantenedores/bancos',
					title: 'Bancos',
					type: 'link',
					seccion: 3
				},
				{ 
					path: '/app/mantenedores/documentos',
					title: 'Documentos',
					type: 'link',
					seccion: 4
				},
                { 
					path: '/app/mantenedores/monedas',
					title: 'Monedas',
					type: 'link',
					seccion: 6
				},
                { 
					path: '/app/mantenedores/formas-pagos',
					title: 'Formas de Pagos',
					type: 'link',
					seccion: 5
				},
				{ 
					path: '/app/mantenedores/tarjetas-pagos',
					title: 'Tarjetas de Pagos',
					type: 'link',
					seccion: 7
				},
                { 
					path: '/app/mantenedores/paises',
					title: 'Países',
					type: 'link',
					seccion: 8
				},
                { 
					path: '/app/mantenedores/regiones',
					title: 'Regiones',
					type: 'link',
					seccion: 9
				},
				{ 
					path: '/app/mantenedores/ciudades',
					title: 'Ciudades',
					type: 'link',
					seccion: 10
				}
            ]
        },
        {
            title: "Centro de Usuarios",
            icon: "icofont-users",
            type: "sub",
            active: false,
            modulo: 7,
            children: [
                { 
					path: '/app/centro-usuarios/usuarios',
					title: 'Usuarios',
					type: 'link',
					seccion: 1
				},
				{ 
					path: '/app/centro-usuarios/bitacora',
					title: 'Bitácora',
					type: 'link',
					seccion: 2
				}
            ]
        },
        {
            title: "Configuraciones",
            icon: "icofont-options",
            type: "sub",
            active: false,
            modulo: 8,
            children: [
                { 
					path: '/app/configuraciones/empresas',
					title: 'Empresas',
					type: 'link',
					seccion: 23
				},
                { 
					path: '/app/configuraciones/sucursales',
					title: 'Sucursales',
					type: 'link',
					seccion: 24
				},
                { 
					path: '/app/configuraciones/bodegas',
					title: 'Bodegas',
					type: 'link',
					seccion: 25
				},
                { 
					path: '/app/configuraciones/periodos',
					title: 'Periodos Contables',
					type: 'link',
					seccion: 26
				},
                { 
					path: '/app/configuraciones/parametros',
					title: 'Parámetros',
					type: 'link',
					seccion: 27
				}
            ]
        }
    ];

    // Array
    items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
